"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileCardZoom = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const download_helper_1 = require("@front/helpers/download.helper");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="file-card-container">
    
    <div class="loading-state" ?hidden="${x => !x.loading && !x.miniLoading}">
        <app-loader></app-loader>
    </div>

    
    <div class="error-state alert alert-danger" ?hidden="${x => !x.error}">
        <i class="simple-icon-exclamation me-2"></i>
        ${x => x.error}
    </div>

    
    <div class="file-content" ?hidden="${x => x.loading || x.miniLoading || !!x.error}">
        ${(0, fast_element_1.when)(x => x.hasMini, (0, fast_element_1.html) `
            
            <div
                class="zoom-card"
                role="button"
                tabindex="0"
                @click="${x => x.openZoom()}"
                @keydown="${(x, c) => x.handleCardKeydown(c.event)}"
            >
                <img class="zoom-thumb" src="${x => x.miniPath}" alt="${x => x.fileName}" />
                <div class="zoom-meta">
                    <div class="zoom-name">${x => x.fileName}</div>
                    <div class="zoom-size">${x => x.fileSize} · ${'file-card.zoomHint'.t()}</div>
                </div>
                <span class="zoom-icon" title="${'file-card.zoom'.t()}">
                    <i class="simple-icon-magnifier"></i>
                </span>
            </div>
            
            ${(0, fast_element_1.when)(x => x.zoomOpen, (0, fast_element_1.html) `
                <div class="zoom-modal" @click="${x => x.closeZoom()}">
                    <button
                        type="button"
                        class="zoom-close"
                        title="${'file-card.close'.t()}"
                        @click="${x => x.closeZoom()}"
                    >
                        <i class="simple-icon-close"></i>
                    </button>
                    <div class="zoom-content" @click="${(x, c) => x.stopEvent(c.event)}">
                        ${(0, fast_element_1.when)(x => x.isImageFile, (0, fast_element_1.html) `
                            <img class="zoom-full" src="${x => x.getFilePath()}" alt="${x => x.fileName}" />
                        `)}
                        ${(0, fast_element_1.when)(x => x.isVideoFile, (0, fast_element_1.html) `
                            <video class="zoom-full" src="${x => x.getFilePath()}" controls autoplay>
                                ${'file-card.videoNotSupported'.t()}
                            </video>
                        `)}
                        <div class="zoom-caption">${x => x.fileName}</div>
                    </div>
                </div>
            `)}
        `, (0, fast_element_1.html) `
        ${(0, fast_element_1.when)(x => x.preview && x.isPreviewableFile, (0, fast_element_1.html) `
            
            <div class="preview-file">
                ${(0, fast_element_1.when)(x => x.isImageFile, (0, fast_element_1.html) `
                    <img 
                        src="${x => x.getFilePath()}" 
                        alt="${x => x.fileName}"
                        class="file-preview-image"
                    />
                `)}
                ${(0, fast_element_1.when)(x => x.isVideoFile, (0, fast_element_1.html) `
                    <video 
                        src="${x => x.getFilePath()}" 
                        class="file-preview-video"
                        controls
                        preload="metadata"
                    >
                        ${'file-card.videoNotSupported'.t()}
                    </video>
                `)}
                <div class="preview-info">
                    <div class="file-name">${x => x.fileName}</div>
                    <div class="file-meta">
                        <span class="file-type">${x => { var _a; return (_a = x.ext) === null || _a === void 0 ? void 0 : _a.toUpperCase(); }}</span>
                        <span class="file-size">${x => x.fileSize}</span>
                    </div>
                </div>
                
                <div class="file-actions" ?hidden="${x => !x.showDownload && !x.showAddToKdb}">
                    ${(0, fast_element_1.when)(x => x.showDownload, (0, fast_element_1.html) `
                        <button 
                            class="btn btn-secondary btn-sm" 
                            @click="${x => x.handleDownload()}"
                            title="${'file-card.download'.t()}"
                        >
                            <i class="simple-icon-cloud-download"></i>
                        </button>
                    `)}
                    ${(0, fast_element_1.when)(x => x.showAddToKdb, (0, fast_element_1.html) `
                        <button 
                            class="btn btn-outline-primary btn-sm" 
                            @click="${x => x.handleAddToKdb()}"
                            title="${'file-card.addToKdb'.t()}"
                        >
                            <i class="simple-icon-book-open"></i>
                        </button>
                    `)}
                </div>
            </div>
        `, (0, fast_element_1.html) `
            
            <div class="non-preview-file">
                <div class="file-item__icon">
                    <i class="simple-icon-paper-clip"></i>
                </div>
                <div class="file-item__info">
                    <div class="file-item__name">${x => x.fileName}</div>
                    <div class="file-item__footer">
                        <div class="file-item__ext">${x => x.ext}</div>
                        <div class="file-item__size">${x => x.fileSize}</div>
                    </div>                    
                </div>
                
                <div class="file-actions" ?hidden="${x => !x.showDownload && !x.showAddToKdb}">
                    ${(0, fast_element_1.when)(x => x.showDownload, (0, fast_element_1.html) `
                        <button 
                            class="btn btn-secondary btn-sm" 
                            @click="${x => x.handleDownload()}"
                            title="${'file-card.download'.t()}"
                        >
                            <i class="simple-icon-cloud-download"></i>
                        </button>
                    `)}
                    ${(0, fast_element_1.when)(x => x.showAddToKdb, (0, fast_element_1.html) `
                        <button 
                            class="btn btn-outline-primary btn-sm" 
                            @click="${x => x.handleAddToKdb()}"
                            title="${'file-card.addToKdb'.t()}"
                        >
                            <i class="simple-icon-book-open"></i>
                        </button>
                    `)}
                </div>
            </div>
        `)}
        `)}
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.file-card-container {
  display: block;
  width: 100%;
}
.file-card-container .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.file-card-container .loading-state .spinner-border {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
}
.file-card-container .error-state {
  margin: 0;
  padding: 0.75rem;
}
.file-card-container .file-content .zoom-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  margin-top: 12px;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #f6f9f8;
  color: inherit;
  cursor: zoom-in;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.file-card-container .file-content .zoom-card:hover, .file-card-container .file-content .zoom-card:focus-visible {
  border-color: #17b4a6;
  background: #eef7f5;
  outline: none;
}
.file-card-container .file-content .zoom-card .zoom-thumb {
  width: 58px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #e4e7ec;
  background-color: #ffffff;
  object-fit: cover;
  object-position: left top;
}
.file-card-container .file-content .zoom-card .zoom-meta {
  flex: 1;
  min-width: 0;
  line-height: 1.2;
}
.file-card-container .file-content .zoom-card .zoom-meta .zoom-name {
  font-weight: 600;
  font-size: 0.9rem;
  word-break: break-word;
}
.file-card-container .file-content .zoom-card .zoom-meta .zoom-size {
  color: #8a8f9c;
  font-size: 0.8rem;
}
.file-card-container .file-content .zoom-card .zoom-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #17b4a6;
  color: #ffffff;
  display: grid;
  place-items: center;
  cursor: zoom-in;
}
.file-card-container .file-content .zoom-card:hover .zoom-icon {
  background: #0f948a;
}
.file-card-container .file-content .zoom-modal {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  background: rgba(0, 0, 0, 0.85);
}
.file-card-container .file-content .zoom-modal .zoom-close {
  position: absolute;
  top: 12px;
  right: 16px;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #eaeaea;
  font-size: 1.1rem;
  cursor: pointer;
}
.file-card-container .file-content .zoom-modal .zoom-close:hover {
  background: rgba(255, 255, 255, 0.15);
}
.file-card-container .file-content .zoom-modal .zoom-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  max-height: 100%;
  cursor: default;
}
.file-card-container .file-content .zoom-modal .zoom-content .zoom-full {
  display: block;
  max-width: 100%;
  max-height: calc(100vh - 120px);
  border-radius: 6px;
}
.file-card-container .file-content .zoom-modal .zoom-content .zoom-caption {
  color: #eaeaea;
  font-size: 0.85rem;
  text-align: center;
}
.file-card-container .file-content .preview-file {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  overflow: hidden;
  background-color: #ffffff;
}
.file-card-container .file-content .preview-file .file-preview-image {
  display: block;
  max-width: 100%;
  height: auto;
  width: 100%;
  object-fit: cover;
  max-height: 300px;
}
.file-card-container .file-content .preview-file .file-preview-video {
  display: block;
  width: 100%;
  max-height: 300px;
  background-color: #000000;
}
.file-card-container .file-content .preview-file .preview-info {
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}
.file-card-container .file-content .preview-file .preview-info .file-name {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
  word-break: break-word;
}
.file-card-container .file-content .preview-file .preview-info .file-meta {
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
}
.file-card-container .file-content .preview-file .preview-info .file-meta .file-type {
  font-size: 0.875rem;
  color: var(--primary-color);
  text-transform: uppercase;
  font-weight: 500;
}
.file-card-container .file-content .preview-file .preview-info .file-meta .file-size {
  font-size: 0.75rem;
  color: #6c757d;
}
.file-card-container .file-content .preview-file .file-actions {
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  display: flex;
  gap: 0.25rem;
  justify-content: flex-end;
}
.file-card-container .file-content .preview-file .file-actions .btn {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
.file-card-container .file-content .preview-file .file-actions .btn i {
  font-size: 0.75rem;
}
.file-card-container .file-content .non-preview-file {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  background-color: #f8f9fa;
}
.file-card-container .file-content .non-preview-file .file-item__icon {
  margin-right: 0.75rem;
  font-size: 1.5rem;
  color: #6c757d;
  flex-shrink: 0;
}
.file-card-container .file-content .non-preview-file .file-item__info {
  flex: 1;
  min-width: 0;
}
.file-card-container .file-content .non-preview-file .file-item__info .file-item__name {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
  word-break: break-word;
}
.file-card-container .file-content .non-preview-file .file-item__info .file-item__footer {
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  align-items: baseline;
}
.file-card-container .file-content .non-preview-file .file-item__info .file-item__footer .file-item__ext {
  font-size: 1rem;
  color: var(--primary-color);
  text-transform: uppercase;
  font-weight: 500;
}
.file-card-container .file-content .non-preview-file .file-item__info .file-item__footer .file-item__size {
  font-size: 0.875rem;
  color: #6c757d;
}
.file-card-container .file-content .non-preview-file .file-actions {
  margin-left: 0.5rem;
  flex-shrink: 0;
  display: flex;
  gap: 0.25rem;
}
.file-card-container .file-content .non-preview-file .file-actions .btn {
  font-size: 0.75rem;
  padding: 0.375rem;
  min-width: 2rem;
}
.file-card-container .file-content .non-preview-file .file-actions .btn i {
  font-size: 0.75rem;
}
.file-card-container .file-content .file-actions {
  margin-top: 0.75rem;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.file-card-container .file-content .file-actions .btn {
  font-size: 0.875rem;
}
.file-card-container .file-content .file-actions .btn i {
  font-size: 0.75rem;
}

@media (max-width: 768px) {
  .file-card-container .file-content .file-actions .btn {
    flex: 1;
    min-width: 0;
  }
}`;
const shadowOptions = { "mode": "open" };
let FileCardZoom = class FileCardZoom extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.error = '';
        this.miniFile = null;
        this.miniLoading = false;
        this.zoomOpen = false;
        this.fileUrl = '';
        this.miniFileUrl = '';
        this.showDownload = true;
        this.showAddToKdb = false;
        this.preview = true;
        this.onKeydown = (e) => {
            if (e.key === 'Escape') {
                this.closeZoom();
            }
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        if (this.fileData) {
            this.file = this.fileData;
            await this.loadFileUrl(this.fileData, false);
        }
        else if (this.fileId) {
            await this.getFile();
        }
        if (this.miniFileData) {
            this.miniFile = this.miniFileData;
            await this.loadFileUrl(this.miniFileData, true);
        }
        console.log('mini', this.miniFile, this.miniFileData);
        console.log('hasmini', this.hasMini);
    }
    fileDataChanged() {
        if (this.fileData) {
            this.file = this.fileData;
            void this.loadFileUrl(this.fileData, false);
        }
    }
    miniFileDataChanged() {
        this.miniFile = this.miniFileData || null;
        if (this.miniFileData) {
            void this.loadFileUrl(this.miniFileData, true);
        }
        else if (this.miniFileId) {
            this.getMiniFile();
        }
        else {
            this.revokeFileUrl(true);
        }
    }
    fileIdChanged() {
        if (this.fileId) {
            this.getFile();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.closeZoom();
        this.revokeFileUrl(false);
        this.revokeFileUrl(true);
    }
    miniFileIdChanged() {
        if (this.miniFileData) {
            this.miniFile = this.miniFileData;
            void this.loadFileUrl(this.miniFileData, true);
        }
        else {
            this.getMiniFile();
        }
    }
    async getMiniFile() {
        this.miniFile = null;
        if (!this.miniFileId) {
            this.miniLoading = false;
            return;
        }
        try {
            this.miniLoading = true;
            const response = await this.apiService.back.get('file.get', {
                routeParams: { id: this.miniFileId },
                ...(this.getToken() ? { headers: { Authorization: `Bearer ${this.getToken()}` } } : {})
            });
            this.miniFile = response.data;
            await this.loadFileUrl(response.data, true);
        }
        catch (e) {
            // Falls back to the regular preview card
            console.error('Error loading mini file:', e);
        }
        finally {
            this.miniLoading = false;
        }
    }
    openZoom() {
        console.log({ thisis: this });
        this.zoomOpen = true;
        document.addEventListener('keydown', this.onKeydown);
    }
    closeZoom() {
        this.zoomOpen = false;
        document.removeEventListener('keydown', this.onKeydown);
    }
    handleCardKeydown(e) {
        const key = e.key;
        if (key === 'Enter' || key === ' ') {
            this.openZoom();
            return false;
        }
        return true;
    }
    stopEvent(e) {
        e.stopPropagation();
    }
    async getFile() {
        try {
            this.loading = true;
            this.error = '';
            const response = await this.apiService.back.get('file.get', {
                routeParams: { id: this.fileId },
                ...(this.getToken() ? { headers: { Authorization: `Bearer ${this.getToken()}` } } : {})
            });
            this.file = response.data;
            await this.loadFileUrl(response.data, false);
        }
        catch (e) {
            console.error('Error loading file:', e);
            this.error = 'file-card.errorLoading'.t();
        }
        finally {
            this.loading = false;
        }
    }
    handleDownload() {
        if (!this.file)
            return;
        try {
            const link = document.createElement('a');
            link.href = download_helper_1.DownloadHelper.getFilePath(this.file);
            link.download = this.file.originalName || this.file.filename || `file-${this.file.id}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (e) {
            console.error('Error downloading file:', e);
        }
    }
    handleAddToKdb() {
        if (!this.file)
            return;
        // Emit event for parent component to handle
        this.$emit('add-to-kdb', { file: this.file });
    }
    get isImageFile() {
        var _a;
        if (!this.file)
            return false;
        return ((_a = this.file.mimeType) === null || _a === void 0 ? void 0 : _a.startsWith('image/')) || false;
    }
    get isVideoFile() {
        var _a;
        if (!this.file)
            return false;
        return ((_a = this.file.mimeType) === null || _a === void 0 ? void 0 : _a.startsWith('video/')) || false;
    }
    get isPreviewableFile() {
        return this.isImageFile || this.isVideoFile;
    }
    get hasMini() {
        return !!this.preview && !!this.miniFile && this.isPreviewableFile;
    }
    get miniPath() {
        return this.miniFile ? this.resolveFilePath(this.miniFile, true) : '';
    }
    get ext() {
        var _a;
        if (!this.file)
            return null;
        return ((_a = this.file.mimeType) === null || _a === void 0 ? void 0 : _a.split('/')[1]) || null;
    }
    get fileName() {
        if (!this.file)
            return 'file-card.unknownFile'.t();
        return this.file.originalName || this.file.filename || 'file-card.unknownFile'.t();
    }
    get fileSize() {
        var _a;
        if (!((_a = this.file) === null || _a === void 0 ? void 0 : _a.size))
            return 'file-card.unknownSize'.t();
        const mbVal = (this.file.size / (1024 * 1024)).toFixed(2);
        return mbVal !== '0.00' ? `${mbVal} MB` : `${(this.file.size / 1024).toFixed(2)} KB`;
    }
    getToken() {
        return this.apiService.token;
    }
    getFilePath() {
        if (!this.file)
            return '';
        return this.resolveFilePath(this.file, false);
    }
    resolveFilePath(file, isMini) {
        if (file.id) {
            return isMini ? this.miniFileUrl : this.fileUrl;
        }
        if (typeof file.path === 'string') {
            return `data:${file.mimeType};base64,${file.path}`;
        }
        return '';
    }
    async loadFileUrl(file, isMini) {
        this.revokeFileUrl(isMini);
        if (!(file === null || file === void 0 ? void 0 : file.id) || !file.filename) {
            return;
        }
        const headers = {};
        const token = this.getToken();
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        try {
            const response = await fetch(download_helper_1.DownloadHelper.getFilePath(file), { headers });
            if (!response.ok) {
                throw new Error(`Failed to load file ${file.id}: HTTP ${response.status}`);
            }
            const objectUrl = URL.createObjectURL(await response.blob());
            if (isMini) {
                this.miniFileUrl = objectUrl;
            }
            else {
                this.fileUrl = objectUrl;
            }
        }
        catch (error) {
            console.error(`Error loading ${isMini ? 'miniature' : 'file'} content:`, error);
            if (!isMini) {
                this.error = 'file-card.errorLoading'.t();
            }
        }
    }
    revokeFileUrl(isMini) {
        const url = isMini ? this.miniFileUrl : this.fileUrl;
        if (url.startsWith('blob:')) {
            URL.revokeObjectURL(url);
        }
        if (isMini) {
            this.miniFileUrl = '';
        }
        else {
            this.fileUrl = '';
        }
    }
};
exports.FileCardZoom = FileCardZoom;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], FileCardZoom.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], FileCardZoom.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _a : Object)
], FileCardZoom.prototype, "file", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _b : Object)
], FileCardZoom.prototype, "miniFile", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], FileCardZoom.prototype, "miniLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], FileCardZoom.prototype, "zoomOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _c : Object)
], FileCardZoom.prototype, "fileData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _d : Object)
], FileCardZoom.prototype, "miniFileData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], FileCardZoom.prototype, "fileUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], FileCardZoom.prototype, "miniFileUrl", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileCardZoom.prototype, "fileId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileCardZoom.prototype, "miniFileId", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], FileCardZoom.prototype, "showDownload", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], FileCardZoom.prototype, "showAddToKdb", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], FileCardZoom.prototype, "preview", void 0);
exports.FileCardZoom = FileCardZoom = __decorate([
    (0, client_1.RWSView)('file-card-zoom', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], FileCardZoom);
FileCardZoom.defineComponent();
